// Only source-defined route templates may be registered here, never locations.
const registered = new Map<string, string>();
export function registerRouteName(patterns: string[]): string {
  const routeSegments = patterns.flatMap((path, index) =>
    path.split("/").filter((part) => part && (part !== "*" || index === patterns.length - 1))
  );
  const route = `/${routeSegments.join("/")}`;
  const staticSegments = routeSegments.filter((part) => part !== "*" && !part.startsWith(":"));
  const name =
    staticSegments
      .map((part) => {
        const words = part
          .replace(/\?$/, "")
          .replace(/[-_]/g, " ")
          .replace(/([a-z])([A-Z])/g, "$1 $2");
        return words.charAt(0).toUpperCase() + words.slice(1);
      })
      .join(" / ") || (routeSegments.includes("*") ? "Other" : "Home");

  registered.set(route, name);
  return route;
}
export const isRegisteredRouteName = (name: unknown) =>
  typeof name === "string" && registered.has(name);

export const getPageLabel = (route: string) => registered.get(route) || "Other";
